
import React from 'react'
import Root from '../components/organisms/Root';
import { HasAccess } from '@permify/react-role';
import TableMedicos from '../components/molecules/TableMedicos';

function Medicos() {
    return (
        <Root active={'medicos'}>
            <HasAccess
                roles={["Administrador"]}
                renderAuthFailed={<p>Erro: Você não tem permissão para acessar essa tela.</p>}
            >
                <TableMedicos tableName="Médicos" />
            </HasAccess>
        </Root>
    );
}


export default Medicos